/**
 * Adapted from Material-UI icons helper
 * https://github.com/mui-org/material-ui/blob/master/packages/material-ui-icons/src/utils/createSvgIcon.js
 */
import { __assign, __rest } from "tslib";
import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core';
export default (function (path, displayName, viewBox) {
    if (viewBox === void 0) { viewBox = '0 0 64 64'; }
    var Component = React.memo(React.forwardRef(function (_a, ref) {
        var size = _a.size, style = _a.style, props = __rest(_a, ["size", "style"]);
        var theme = useTheme();
        var finalSize = size && parseSize(size, theme);
        return (React.createElement(SvgIcon, __assign({ viewBox: viewBox, "data-icon": displayName + "Icon", ref: ref, style: !!size ? __assign(__assign({}, style), { fontSize: finalSize }) : style }, props), path));
    }));
    Component.displayName = displayName + "Icon";
    // @ts-ignore
    Component.muiName = SvgIcon.muiName;
    return Component;
});
var parseSize = function (size, theme) {
    if (typeof size === 'number')
        return size;
    switch (size) {
        case 'xs':
            return theme.spacing(1);
        case 'sm':
            return theme.spacing(2);
        case 'md':
            return theme.spacing(3);
        case 'lg':
            return theme.spacing(4);
        case 'xl':
            return theme.spacing(5);
        default:
            return size;
    }
};
//# sourceMappingURL=createSvgIcon.js.map